import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-captcha",
  "use": "icon-captcha-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-captcha\">\n  <path d=\"M256 128h512a64 64 0 0 1 64 64v640a64 64 0 0 1-64 64H256a64 64 0 0 1-64-64V192a64 64 0 0 1 64-64z m0 64v640h512V192H256z m64 96h128v64H320v-64z m192 0h128v64H512v-64z m192 0h128v64H704v-64z m-384 128h128v64H320v-64z m192 0h128v64H512v-64z m192 0h128v64H704v-64z m-384 128h128v64H320v-64z m192 0h128v64H512v-64z m192 0h128v64H704v-64z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/captcha.svg
// module id = KpXy
// module chunks = 29